/**
 * Labstep
 *
 * @module screens/ExperimentWorkflow/Index/Grid/LeftPane
 * @desc ExperimentWorkflow Index LeftPane
 */

import { ExperimentWorkflowPostFilterPane } from 'labstep-web/components/ExperimentWorkflow/PostFilter/Pane';
import ExperimentWorkflowPostFilterPrimaryList from 'labstep-web/components/ExperimentWorkflow/PostFilter/Primary/List';
import { ExperimentWorkflowPostFilterSignedList } from 'labstep-web/components/ExperimentWorkflow/PostFilter/Signed/List';
import ExperimentWorkflowPostFilterStatusList from 'labstep-web/components/ExperimentWorkflow/PostFilter/Status/List';
import { FolderPane } from 'labstep-web/components/Folder/Pane';
import { LayoutLeftPane } from 'labstep-web/components/Layout/LeftPane';
import { ParamsStateContextProvider } from 'labstep-web/contexts/params-state';
import { FolderType } from 'labstep-web/models/folder.model';
import type React from 'react';

export const ExperimentWorkflowIndexGridLeftPane: React.FC = () => (
  <LayoutLeftPane>
    <ParamsStateContextProvider value={{}}>
      <FolderPane folderType={FolderType.experiment_workflow} />
    </ParamsStateContextProvider>
    <ParamsStateContextProvider
      value={{ destination: 'experiment_workflow_index' }}
    >
      <ExperimentWorkflowPostFilterPrimaryList />
      <ExperimentWorkflowPostFilterStatusList />
      <ExperimentWorkflowPostFilterSignedList />
      <ExperimentWorkflowPostFilterPane />
    </ParamsStateContextProvider>
  </LayoutLeftPane>
);
